import React from "react";
import ChatBox from "./components/ChatBox";

function App() {
  return (
    <div>
      <ChatBox />
    </div>
  );
}

export default App;
